import * as Sentry from "@sentry/browser";
import LogRocket from "logrocket";

// Sentry
export const initSentry = () => {
  if (process.env.REACT_APP_SENTRY_DSN) {
    Sentry.init({ dsn: process.env.REACT_APP_SENTRY_DSN });
  }
};

// https://docs.sentry.io/platforms/javascript/react/
export const logToSentry = (error, errorInfo = {}) => {
  if (process.env.REACT_APP_SENTRY_DSN) {
    Sentry.withScope((scope) => {
      scope.setExtras(errorInfo);
      Sentry.captureException(error);
    });
  }
};

// LogRocket
export const initLogRocket = () => {
  if (process.env.REACT_APP_LOG_ROCKET_ID) {
    LogRocket.init(process.env.REACT_APP_LOG_ROCKET_ID);
  }
};

export const initTelemetry = () => {
  initSentry();
  initLogRocket();

  if (process.env.REACT_APP_LOG_ROCKET_ID) {
    // https://docs.logrocket.com/docs/sentry
    LogRocket.getSessionURL((sessionURL) => {
      Sentry.configureScope((scope) => {
        scope.setExtra("sessionURL", sessionURL);
      });
    });
  }
};
